import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import { InlineLinkDarkControl as InlineLink } from '../controls/inline-link-control';
export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <p>
  A levy liability is a liability to pay the MSA Levy. It is calculated using the data contained in the environment mitigation information system and the levy prices set under the{' '} <InlineLink href="https://content.legislation.vic.gov.au/sites/default/files/2020-02/20-001aa%20authorised.pdf" text="Melbourne Strategic Assessment (Environment Mitigation Levy) Act 2020" mdxType="InlineLink" />.
    </p>
    <p>
  This tool produces a levy liability estimate (at current rates). An estimate is not an invoice.
    </p>
    <p>
  The levy only applies to land within the MSA Levy Area Boundary. Levy payments are only required if a levy event occurs and is only ever required on any area of land once. 
    </p>
    <p>
  This levy goes towards funding our conservation reserves and programs.
    </p>
    <p>
  Levy prices are published on the{' '} <InlineLink href="https://www.msa.vic.gov.au/" text="MSA website" mdxType="InlineLink" /> and in the Government Gazette.
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      